import './registerList'
import './registerBlog'
import './registerFeatures'
import './registerNews'
import './registerPanel'
import './registerMedia'
import './registerPartner'
